import { Wallet } from "lucide-react";
import type { BudgetSummary } from "../types";
import { Card, CardHeader, formatCurrency } from "./_shared";

type Props = {
  summary: BudgetSummary;
  currency?: string;
};

export function BudgetSummaryWidget({ summary, currency = "AED" }: Props) {
  const { totalBudget, totalSpent, utilizationPercent } = summary;
  const remaining = Math.max(0, totalBudget - totalSpent);
  const pct = Math.min(100, Math.max(0, utilizationPercent));
  const barColor =
    pct >= 90
      ? "hsl(0,70%,55%)"
      : pct >= 75
        ? "hsl(35,90%,50%)"
        : "hsl(142,72%,29%)";

  return (
    <Card>
      <CardHeader
        icon={
          <Wallet
            className="h-4 w-4 text-[hsl(142,72%,28%)]"
            strokeWidth={1.5}
          />
        }
        title="Budget Summary"
      />
      <div>
        <div className="text-[11px] uppercase text-muted-foreground">
          Total Budget
        </div>
        <div className="mt-1 text-[24px] font-bold leading-none text-foreground">
          {formatCurrency(totalBudget, currency)}
        </div>
      </div>
      <div className="mt-3">
        <div
          className="flex items-center overflow-hidden rounded-full"
          style={{ height: 10, background: "hsl(210,16%,93%)" }}
        >
          <div
            style={{
              width: `${pct}%`,
              height: "100%",
              background: barColor,
            }}
          />
        </div>
        <div className="mt-2 flex items-center justify-between text-[12px]">
          <span className="text-muted-foreground">
            Spent:{" "}
            <span className="font-medium text-foreground">
              {formatCurrency(totalSpent, currency)}
            </span>
          </span>
          <span className="text-muted-foreground">
            Remaining:{" "}
            <span className="font-medium text-foreground">
              {formatCurrency(remaining, currency)}
            </span>
          </span>
        </div>
        <div className="mt-1 text-[12px] text-muted-foreground">
          Utilization:{" "}
          <span className="font-semibold" style={{ color: barColor }}>
            {utilizationPercent}%
          </span>
        </div>
      </div>
    </Card>
  );
}
